export function compareDate(date) {
    const [year, month, day] = date.split('-');
    const formattedDate = new Date(year, month - 1, day);
    const currentDate = new Date();
    const twoDaysFromNow = new Date();
    twoDaysFromNow.setDate(currentDate.getDate() + 2);
    const isExpiring =
        formattedDate.getTime() >= currentDate.getTime() && formattedDate.getTime() <= twoDaysFromNow.getTime();
    const isExpired = formattedDate.getTime() < currentDate.getTime();
    return {
        isExpiring,
        isExpired
    };
}
